import { Routes, Route, Navigate } from 'react-router-dom';
import './admin.css';
import LoginPage from './LoginPage';
import AdminLayout from './AdminLayout';
import ProtectedRoute from './ProtectedRoute';
import Dashboard from './modules/Dashboard';
import EventsManager from './modules/EventsManager';
import GalleryManager from './modules/GalleryManager';
import NewsManager from './modules/NewsManager';
import DocumentsManager from './modules/DocumentsManager';
import AboutManager from './modules/AboutManager';
import FaqManager from './modules/FaqManager';
import ContentEditor from './modules/ContentEditor';
import MembersManager from './modules/MembersManager';
import MediaManager from './modules/MediaManager';
import UserManager from './modules/UserManager';
import HeroManager from './modules/HeroManager';
import MessagesManager from './modules/MessagesManager';
import BroadcastManager from './modules/BroadcastManager';
import PartnersManager from './modules/PartnersManager';
import MilestonesManager from './modules/MilestonesManager';
import CricketClubManager from './modules/CricketClubManager';

export default function AdminApp() {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route path="*" element={
        <ProtectedRoute>
          <AdminLayout>
            <Routes>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="members" element={<MembersManager />} />
              <Route path="events" element={<EventsManager />} />
              <Route path="gallery" element={<GalleryManager />} />
              <Route path="news" element={<NewsManager />} />
              <Route path="documents" element={<DocumentsManager />} />
              <Route path="about" element={<AboutManager />} />
              <Route path="faq" element={<FaqManager />} />
              <Route path="content" element={<ContentEditor />} />
              <Route path="media" element={<MediaManager />} />
              <Route path="users" element={<UserManager />} />
              <Route path="hero" element={<HeroManager />} />
              <Route path="messages" element={<MessagesManager />} />
              <Route path="broadcast" element={<BroadcastManager />} />
              <Route path="partners" element={<PartnersManager />} />
              <Route path="milestones" element={<MilestonesManager />} />
              <Route path="cricketclub" element={<CricketClubManager />} />
            </Routes>
          </AdminLayout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}
